import { ServiceBase } from '../../../../core/services/ServiceBase'
import CategoryProxy from './CategoryProxy'

class CategoryService extends ServiceBase {
  getOwnershipTypes(params) {
    return this.getData(() => CategoryProxy.getOwnershipTypes(params))
  }
}

export default new CategoryService()
